import React from 'react';
import ProgressBar from '../../../ui/ProgressBar';
import './ProfessionProgress.css';

const number = value => Math.max(0, Number(value) || 0);

export default function ProfessionProgress({ profession }) {
  if (!profession) return null;

  const name = profession.name || profession.professionKey || 'Profession';
  const level = Math.max(1, Math.floor(number(profession.level)));
  const experience = number(profession.experience);
  const levelStartExperience = Math.min(
    experience,
    number(profession.levelStartExperience),
  );
  const nextLevelExperience = profession.nextLevelExperience == null
    ? null
    : Math.max(levelStartExperience, number(profession.nextLevelExperience));
  const progress = nextLevelExperience == null
    ? 100
    : ((experience - levelStartExperience) / Math.max(
      1,
      nextLevelExperience - levelStartExperience,
    )) * 100;
  const experienceText = nextLevelExperience == null
    ? `${experience.toLocaleString('en-US')} XP · Max level`
    : `${experience.toLocaleString('en-US')} / ${nextLevelExperience.toLocaleString('en-US')} XP`;

  return (
    <section aria-label={`${name} progress`} className="camp-profession-progress">
      <div className="camp-profession-progress__heading">
        <strong>{name}</strong>
        <span>Level {level}</span>
      </div>
      <ProgressBar
        label={nextLevelExperience == null
          ? `${name} is at max level`
          : `${name} progress: ${experience} of ${nextLevelExperience} experience`}
        value={progress}
        variant="xp"
      />
      <span className="camp-profession-progress__experience">
        {experienceText}
      </span>
    </section>
  );
}
